// THIS CODE WAS AUTO-GENERATED from '/packages/icon/src/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...props}>
    <path d="M12 3.3c-5.5 0-10 3.5-10 7.9 0 2.8 1.8 5.3 4.6 6.7l-.9 3.5c0 .2.1.3.2.4h.2l4-2.8c.6.1 1.2.1 1.9.1 5.5 0 10-3.5 10-7.9s-4.5-7.9-10-7.9zM7 13.4c0 .2-.3.4-.5.4s-.5-.2-.5-.4V9.9H5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h3c.3 0 .5.2.5.5s-.2.5-.5.5H7v3.5zm4.2.1-.2-.7H9l-.2.6c-.1.3-.4.4-.6.3-.2-.1-.3-.4-.3-.6l1.4-3.8c.1-.4.5-.6.9-.4.2.1.3.2.4.4l1.4 3.8c.1.2 0 .5-.2.6s-.5 0-.6-.2zm1.8.2c-.3 0-.5-.2-.5-.5V9.4c0-.3.2-.5.5-.5s.5.2.5.5v3.5h1.3c.3 0 .5.2.5.4 0 .3-.2.4-.5.4H13zm5.4-.1L17 11.8l-.4.4v1.1c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5s.5.2.5.5v1.5l1.7-1.7c.2-.2.5-.2.7 0s.2.5 0 .7l-1.3 1.3 1.5 1.9c.2.2.1.5-.1.7s-.5.1-.7-.1zm-9.2-1.7h1.4l-.7-2-.7 2z" />
  </BaseIcon>
)
